module.exports = __webpack_public_path__ + "img/israel.c97238c5.svg";